import { Settings } from '@ais-ui/websockets';

const headersToObject = (headersArray: string[]) => {
  const headers: Record<string, string> = {};
  headersArray.forEach((header) => {
    const [key, value] = header.split('=');
    headers[key] = value;
  });
  return headers;
};

export const getOsmUrlHeadersFromSettings = (settings: Settings) => {
  const url = `${settings['assetDisplay.mapengine'].osmBaseUrl}/{z}/{x}/{y}.png`;
  const headersArray = settings['assetDisplay.mapengine'].osmHeaders;
  const headers = headersToObject(headersArray);

  return { url, headers };
};
